"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductTitle;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ProductTitle(_ref) {
  var productName = _ref.productName,
    testCase = _ref.testCase;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pega-details-".concat(testCase, "-product-name")
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, productName)));
}
ProductTitle.propTypes = {
  productName: _propTypes.default.string,
  testCase: _propTypes.default.string
};